export default "__VITE_ASSET__732OWlh2__"